import React, { useState } from 'react';
import { toast } from 'sonner';
import { Check, Copy, MessageCircle, Settings, X, PartyPopper } from 'lucide-react';
import { copyText, mgmtShareMsg, waLink } from './smartqrApi';

export const PremiumSuccessModal = ({ businessName, managementUrl, onClose }) => {
  const [copied, setCopied] = useState(false);
  if (!managementUrl) return null;

  const doCopy = async () => {
    const ok = await copyText(managementUrl);
    if (ok) { setCopied(true); toast.success('Management link copied'); setTimeout(() => setCopied(false), 2500); }
    else toast.error('Copy failed — long-press the link below to copy it manually');
  };

  return (
    <div className="fixed inset-0 z-[100] bg-slate-900/70 backdrop-blur-sm flex items-end sm:items-center justify-center p-4" data-testid="premium-success-modal" onClick={onClose}>
      <div className="bg-white w-full max-w-md rounded-2xl p-6 relative shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-3 right-3 p-1.5 text-slate-400 hover:text-slate-700" aria-label="Close" data-testid="premium-success-close"><X className="w-5 h-5" /></button>
        <div className="w-14 h-14 rounded-full bg-green-100 text-green-600 flex items-center justify-center mx-auto mb-3"><PartyPopper className="w-7 h-7" /></div>
        <h2 className="text-lg font-extrabold text-slate-800 text-center">PREMIUM ACTIVATED</h2>
        <p className="text-sm text-slate-500 text-center mt-1">Payment verified for <span className="font-semibold text-slate-700">{businessName}</span>. Save your private management link now — you need it to edit your page.</p>

        <div className="mt-4 bg-slate-50 border border-slate-200 rounded-xl p-3">
          <p className="text-[11px] font-bold text-slate-500 tracking-wide mb-1">YOUR MANAGEMENT LINK (KEEP PRIVATE)</p>
          <p className="text-xs font-mono text-slate-800 break-all select-all" data-testid="premium-success-link">{managementUrl}</p>
        </div>

        <div className="mt-4 space-y-2">
          <button onClick={doCopy} className="w-full bg-slate-800 hover:bg-slate-900 text-white py-3 rounded-xl font-semibold text-sm flex items-center justify-center gap-2 transition-colors" data-testid="premium-success-copy-btn">
            {copied ? <Check className="w-4 h-4 text-green-400" /> : <Copy className="w-4 h-4" />} {copied ? 'COPIED!' : 'COPY MANAGEMENT LINK'}
          </button>
          <a href={waLink('', mgmtShareMsg(businessName, managementUrl))} target="_blank" rel="noreferrer" className="w-full bg-[#25D366] hover:bg-[#1ebe5b] text-white py-3 rounded-xl font-semibold text-sm flex items-center justify-center gap-2 transition-colors" data-testid="premium-success-wa-btn">
            <MessageCircle className="w-4 h-4" /> SHARE ON WHATSAPP
          </a>
          <a href={managementUrl} className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-xl font-bold text-sm flex items-center justify-center gap-2 transition-colors" data-testid="premium-success-manage-btn">
            <Settings className="w-4 h-4" /> MANAGE BUSINESS PAGE
          </a>
        </div>
        <p className="text-[11px] text-slate-400 text-center mt-3">This link is also shown on your My QR page. Anyone with it can edit your page — share only with yourself.</p>
      </div>
    </div>
  );
};
